import React from 'react';

const PageTitle = (props) => {
    var classString = 'display-5 '
    classString += props.color ? `${props.color}-text` : 'black-text';
    
    return (
        <h1 className={classString}  style={styles.titleStyle}>{props.children}</h1>
    )
};

const SubTitle = (props) => {
    var classString = 'display-4 '
    classString += props.color ? `${props.color}-text` : 'white-text';
    
    return (
        <h1 className={classString}  style={styles.titleStyle}>{props.children}</h1>
    )
};

export { PageTitle, SubTitle };

const styles = {
    titleStyle: {
        color: '#FFFFFF',
        fontSize: 50,
        fontWeight: 600,
        textAlign: 'center',
    }
}